import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const getSpecialProjectController = customSetting.getSpecialProjectController;
const getSpecialProject = self.customSetting.getSpecialProject;
const postSpecialProject = self.customSetting.postSpecialProject;

export default {
  // 2-1
  getApplySpcDataA: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/IintSpcData`)
        .then((res) => {
          context.commit("GET_APPLY_SPCDATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /*getSignerList: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/GetEmp?word=${query}`)
        .then((res) => {
          context.commit("GET_SIGNER_LIST", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },**/
  /*getSignerList: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/GetEmp?word=${query}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },*/
  getSigner: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/GetEng?word=${query}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delInsuranceFile: (context, { fileName, fileId }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getSpecialProject}/DeleteFile?fileName=${fileName}&fileId=${fileId}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  submitSpcApply: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postSpecialProject}/InsertSpecialData`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-2
  getSpecialList: () => {
    return axios.get(`${baseApi}/${getSpecialProject}/GetSpecialList`);
  },
  updSpecialStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postSpecialProject}/UpdSpecialStatus`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSpecialDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/GetSpecialDetail?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSpcPrintFormInfo: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getSpecialProject}/GetSpcPrintFormInfo?prjNo=${prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-3
  getViewSpcSignOffList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getSpecialProject}/ViewSpcSignOffList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSpcViewSignOffDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getSpecialProject}/ViewSpcSignOffDetail?prjNo=${prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  specialrProjectDownloadPdf: (context, file_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getSpecialProject}/DownloadPdf?file_id=${file_id}`,
        methods: "GET",
        responseType: "blob",
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
